// extracted by mini-css-extract-plugin
export default {"select":"Select_select__Z8qTo","selectWrapper":"Select_selectWrapper__gfcts"};